import { useEffect } from 'react';
import { api } from '../lib/api';
import { useAuth } from '../contexts/AuthContext';

function safeMessage(value) {
    return String(value || 'Unknown client error')
        .replace(/Bearer\s+[A-Za-z0-9._-]+/gi, 'Bearer [redacted]')
        .replace(/[?&]auth=[^&\s]+/gi, '?auth=[redacted]')
        .slice(0, 500);
}

export default function ErrorMonitor() {
    const { user } = useAuth();
    useEffect(() => {
        if (!user || user.is_guest) return undefined;
        let lastSent = 0;
        const send = (message, source) => {
            const now = Date.now();
            if (now - lastSent < 3000) return;
            lastSent = now;
            api.post('/monitor/client-error', {
                message: safeMessage(message), source,
                route: window.location.pathname,
                app_version: process.env.REACT_APP_VERSION || 'web',
                platform: window.Capacitor?.getPlatform?.() || 'web',
            }).catch(() => {});
        };
        const onError = (event) => send(event.error?.message || event.message, 'window.error');
        const onReject = (event) => send(event.reason?.message || event.reason, 'unhandledrejection');
        const onRender = (event) => send(event.detail?.message, event.detail?.source || 'render');
        window.addEventListener('error', onError);
        window.addEventListener('unhandledrejection', onReject);
        window.addEventListener('gd:client-error', onRender);
        return () => {
            window.removeEventListener('error', onError);
            window.removeEventListener('unhandledrejection', onReject);
            window.removeEventListener('gd:client-error', onRender);
        };
    }, [user]);
    return null;
}
